import React, { useEffect, useRef, useState } from "react";
import crashImage from "assets/puzzles/iserba/roadSafety/crash.svg";
import successImage from "assets/puzzles/iserba/roadSafety/success.svg";
import TypewriterText from "components/shared/TypeWriterText";

const Game3ValidationScreen = ({ isPuzzleCorrect, onRetry, onNext }) => {
	const gridRef = useRef(null);
	const [gridSize, setGridSize] = useState(0);
	const [backgroundImage, setBackgroundImage] = useState("none");
	const [showCrashDetails, setShowCrashDetails] = useState(false);
	const [isRetryEnabled, setIsRetryEnabled] = useState(false);
	const [isContinueEnabled, setIsContinueEnabled] = useState(false);

	const success = isPuzzleCorrect.scene_1_correct;

	useEffect(() => {
		const updateSize = () => {
			if (gridRef.current) {
				const size = Math.min(window.innerWidth, window.innerHeight - 300);
				setGridSize(size);
			}
		};
		updateSize();
		window.addEventListener("resize", updateSize);
		return () => window.removeEventListener("resize", updateSize);
	}, []);

	const handleClickNext = () => {
		return onNext();
	};

	useEffect(() => {
		if (!success) {
			setBackgroundImage(`url(${crashImage})`);
			// After 2 seconds, show crash details and enable retry button
			setTimeout(() => {
				setBackgroundImage(`none`);
				setShowCrashDetails(true);
				setIsRetryEnabled(true);
			}, 2000);
		} else {
			setBackgroundImage(`url(${successImage})`);
			setIsContinueEnabled(true);
		}
	}, [success]);

	return (
		<div className="flex flex-col items-start">
			<div
				ref={gridRef}
				className="relative m-auto w-full aspect-square border-black bg-white border-8 shadow-[5px_5px_0px_rgba(0,0,0,1)]"
				style={{
					width: gridSize,
					height: gridSize,
					backgroundImage: backgroundImage,
					backgroundColor: showCrashDetails ? "black" : "white",
					color: showCrashDetails ? "white" : "black",
					backgroundSize: "60%",
					backgroundRepeat: "no-repeat",
					backgroundPosition: "center",
				}}
			>
				{success && (
					<h3 className="absolute bottom-4 right-4 left-4 py-4 px-6 bg-white text-sm font-bold text-center">
						Vous avez bien raison, ne vous laissez pas distraire !
					</h3>
				)}
				{showCrashDetails && (
					<div
						className="flex justify-center items-center p-4"
						style={{ width: gridSize + "px", height: "100%" }}
					>
						<div className="whitespace-pre-wrap break-words text-center text-white">
							<TypewriterText
								text={
									"La route est plus importante que ce que peux vous montrer votre collègue. \n\n Vous auriez dû tourner, et vous êtes arrivé dans un mur!"
								}
							/>
						</div>
					</div>
				)}
			</div>
			<div className="mt-4 h-24 px-4 mb-8 flex w-full justify-end items-center gap-0">
				{!success && isRetryEnabled && (
					<button
						onClick={onRetry}
						className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
					>
						Rééssayer
					</button>
				)}
				{success && isContinueEnabled && (
					<button
						onClick={handleClickNext}
						className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
					>
						Continuer
					</button>
				)}
			</div>
		</div>
	);
};

export default Game3ValidationScreen;
